import { StorageGetNextListPage, StorageListPage } from '../common/list-page';
import { ZohoItem } from './zoho.item';

export class ZohoListPage implements StorageListPage {
  constructor(
    private readonly storage: StorageGetNextListPage,
    private readonly items: ZohoItem[],
    private readonly onlyFolders: boolean,
    private readonly hasMore: boolean,
    private readonly nextOffset: number | undefined,
    private readonly folderId: string,
  ) {}

  public getItems(): ZohoItem[] {
    return this.items;
  }

  public hasNext(): boolean {
    return this.hasMore;
  }

  public async getNext(): Promise<StorageListPage> {
    if (!this.hasNext()) {
      throw new Error('Next page requested for the last page.');
    }

    return this.storage.getNextFolderPage(this.onlyFolders, {
      folderId: this.folderId,
      pageOffset: this.nextOffset,
    });
  }
}
